import { Component, OnInit, Input } from '@angular/core';

import { WidgetConfiguration, GenericTableConfiguration } from '../../../../interfaces/WidgetInterfaces';
import { ManagedCacheHitLog, DataSet } from '../../../../interfaces/DisplayInterfaces';
import { WebPlatformApiService } from '../../../../services/WebPlatformApiService';
import { AppStateService } from '../../../../services/AppStateService';

import { IChartSeries } from './../../../highchart-platform/highchart-platform-interfaces'
import { HighChartDataAdapter } from './../../../highchart-platform/highchart-platform-data-adapter'


@Component({
  selector: 'app-server-hit-logs',
  template: `<div class="container-fluid">

  <button type="button" class="btn btn-primary btn-sm" (click)="Refresh()">
    <i _ngcontent-c24="" class="fa fa-refresh"></i> Refresh
  </button>

  <!-- box plot without outliers examle-->
  <app-highchart-platform *ngIf="boxAndWhiskerData" [id]="'serverCacheHitLogBoxPlot'" [data]="boxAndWhiskerData" [title]="'Elapsed ms by policy'" [type]="'boxplot'"></app-highchart-platform>
  
  <app-platform-table *ngIf="sourceDataSet" [Dataset]="sourceDataSet" [Config]="tableConfig"></app-platform-table>
</div>

`,
  styles: [``]
})
export class ServerHitLogsComponent {

  @Input() Config: WidgetConfiguration[];

  tableConfig: GenericTableConfiguration = {
    sortAndfilterLocally: true,
    showFilterSortRow: true,
    showColumnDropdowns: true    
  };
  
  boxAndWhiskerData: IChartSeries[];
  sourceDataSet: DataSet;
  
  constructor(private WebPlatformApiService: WebPlatformApiService, private appStateService: AppStateService) { }

  Refresh() {

    this.WebPlatformApiService.GetManagedCacheHitLogs().subscribe(
      reply => {
        this.sourceDataSet = { columns: ['Policy', 'Client', 'Status', 'Ms'], data: [] };

        this.sourceDataSet.data = reply.map<string[]>( x => {
          return [x.dataPolicy, x.client, x.Status, x.elapsedMs.toString()];
        });

        this.prepareHighChartData();
      },
      error => this.appStateService.appendLog('GetManagedCacheHitLogs ERROR: ' + JSON.stringify(error), 1));
  }

    private prepareHighChartData() {
        let tempBoxplotArr = [];
        tempBoxplotArr = HighChartDataAdapter.createBoxplotSeries(this.sourceDataSet, 'Policy', 'Ms', null, true);
        // if you want to add new object to data series
        // tempBoxplotArr.push(new abject in data series );
        this.boxAndWhiskerData = tempBoxplotArr;
    }
}
